export const PAGE_SIZE = 100;

export const MAX_SELECTED_CAMERAS = 30;

export const MAX_COLS = 4;
export const MAX_ROWS = 4;

export const GRID_GAP_PX = 8;

export const MAX_AUTO_CAMERAS = MAX_COLS * MAX_ROWS;

export const MAX_MOUNTED_TABS = 1;

export interface GridSize {
  rows: number;
  cols: number;
}

export function getGridSizeLabel(size: GridSize | null): string {
  return size ? `${size.cols}×${size.rows}` : 'Auto';
}
